import { setURL } from '@/api/apiUtil'

export default {
  // 根據社區編號取得瓦斯登記列表
  getGasRegistrationList: {
    url: (communityId) =>
      setURL('/gasRegistration/community/:communityId', { communityId }),
    method: 'get'
  },
  // 根據瓦斯登記編號取得瓦斯登記詳細資訊
  getGasRegistration: {
    url: (gasRegistrationId) =>
      setURL('/gasRegistration/info/:gasRegistrationId', { gasRegistrationId }),
    method: 'get'
  },
  // 根據瓦斯登記編號修改根據瓦斯登記
  editPaymentNotice: {
    url: (gasRegistrationId) =>
      setURL('/gasRegistration/:gasRegistrationId', { gasRegistrationId }),
    method: 'put'
  },
  // 根據瓦斯登記編號刪除瓦斯登記
  deletePaymentNotice: {
    url: (gasRegistrationId) =>
      setURL('/gasRegistration/:gasRegistrationId', { gasRegistrationId }),
    method: 'delete'
  },
  // 新增瓦斯登記項目
  addGasRegistration: {
    url: setURL('/gasRegistration'),
    method: 'post'
  },
  // 發送瓦斯登記推播通知
  sendGasRegistrationNotification: {
    url: setURL('/gasRegistration/notification'),
    method: 'post'
  },
  // 根據戶別編號取得每期使用度數列表
  getGasHouseholdRegistration: {
    url: (householdId) =>
      setURL('/gasHouseholdRegistration/household/:householdId', {householdId}),
    method: 'get'
  },
  // 戶別登記列表匯出CSV
  getGasHouseholdRegistrationCSV: {
    url: (gasRegistrationId) =>
      setURL('/gasHouseholdRegistration/:gasRegistrationId/export', {gasRegistrationId}),
    method: 'get'
  },
  // 根據社區編號取得當期瓦斯登記
  getCurrentGasHouseholdRegistration: {
    url: (communityId) =>
      setURL('/gasRegistration/current/community/:communityId', {communityId}),
    method: 'get'
    },
  // 根據瓦斯登記編號取得瓦斯戶別登記列表
  getHouseholdRegistration: {
    url: (gasRegistrationId) =>
      setURL('/gasHouseholdRegistration/:gasRegistrationId', {gasRegistrationId}),
    method: 'get'
    },
}
